import { SCALE, SIZE_COVER } from '../constants';
import ConsolidationTable from './ConsolidationTable';
import bgCover from '@/assets/image/pdfexport/bg-cover.png';
import HorizontalBarChart from '@/new-components/CRConsolidationReportPDF/components/HorizontalBarChart';
import CRPreviewSection from '@/new-components/CRReportHTML/components/common/Section';
import { Box, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';

const ConsolidationSection = ({ id, item }) => {
  const title = item?.businessUnit || 'N/A';
  const pillText = `${item?.year || ''}  ${item?.groupValue || ''}`.trim();

  const hasChart = Array.isArray(item?.chartData) && item.chartData.length > 0;
  const healthScreenings =
    item?.tableData?.healthScreenings || item?.healthScreenings || null;

  const legend = useMemo(
    () => [
      { color: '#F5C5D5', label: 'Female' },
      { color: '#E2F2FF', label: 'Male' },
    ],
    []
  );

  return (
    <Box
      id={id}
      style={{
        padding: `0 ${80 * SCALE}px`,
        // Landscape page like PDF (842x595): swap cover dimensions
        width: SIZE_COVER.height * SCALE,
        minHeight: SIZE_COVER.width * SCALE,
        margin: '0 auto',
        backgroundImage: `url(${bgCover})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        paddingTop: `${64 * SCALE}px`,
      }}
    >
      <Box display="flex" flexDirection="column" minHeight="100%">
        <Typography variant="h6" style={{ fontWeight: 700 }}>
          {title}
        </Typography>

        <Box mt={2 * SCALE}>
          <CRPreviewSection title={pillText || '\u00A0'} />
        </Box>

        <Box mt={3} display="flex" alignItems="stretch" gridGap={24}>
          <Box flex="1 1 auto" minWidth={0} height={340}>
            {hasChart ? (
              <HorizontalBarChart
                chartData={item.chartData}
                animationDuration={0}
                fontSize={12}
                groupLabelFontSize={10}
              />
            ) : null}
          </Box>

          <Box width={180} flex="0 0 180px" display="flex" alignItems="center">
            <Box display="flex" flexDirection="column" gridGap={16}>
              {legend.map((l) => (
                <Box
                  key={l.label}
                  display="flex"
                  alignItems="center"
                  gridGap={12}
                >
                  <Box
                    width={52}
                    height={26}
                    borderRadius={6}
                    style={{ background: l.color }}
                  />
                  <Typography variant="body2" style={{ fontWeight: 600 }}>
                    {l.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box mt={2} px={2} pb={2}>
          <ConsolidationTable healthScreenings={healthScreenings} />
        </Box>
      </Box>
    </Box>
  );
};

export default ConsolidationSection;
